module.exports = __webpack_public_path__ + "assets/svg/UI/crown-814199.svg";